import { useQuery } from "@apollo/client";
import React from "react";
import { useEffect, useState } from "react";

import Loading from "../common/Loading";
import { captureException } from "../sentry";
import { pollQuery, PollQueryType, PollQueryVariables } from "./AiExercise.gql";
import { StyledImage } from "./Exercise.sc";

interface Props {
    pollingId: string | undefined;
}

export function AiImages({ pollingId }: Props) {
    const [pollInterval, setPollInterval] = useState(0);

    const { data, loading, error } = useQuery<PollQueryType, PollQueryVariables>(pollQuery, {
        variables: {
            pollingId: pollingId ?? "",
        },
        skip: !pollingId,
        pollInterval,
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
        onError: (error) => {
            captureException(error);
        },
        onCompleted: (data) => {
            if (data.poll.reskined_image_url && data.poll.reskined_image_url !== "PENDING") {
                setPollInterval(0);
            }
        },
    });

    useEffect(() => {
        if (pollingId) {
            setPollInterval(1000);
        }
    }, [pollingId]);

    const reskinnedError = error || (data?.poll?.reskined_image_url?.startsWith("ERROR") && { message: data?.poll?.reskined_image_url?.slice(7) });
    const reskinnedLoading = loading || data?.poll?.reskined_image_url === "PENDING";
    const reskinnedImageUrl = data?.poll?.reskined_image_url && !reskinnedError && !reskinnedLoading ? data?.poll?.reskined_image_url : undefined;

    return (
        <div style={{ position: "relative", width: "100%", minHeight: 200 }}>
            <div>
                {reskinnedLoading && <Loading />}
                {reskinnedError && <div>Error: {reskinnedError.message}</div>}
                {reskinnedImageUrl && <StyledImage src={reskinnedImageUrl} />}
            </div>
        </div>
    );
}
